import createLazy from 'components/common/lazy';
import vHistory, { PATH_PREFIX, VPathKey } from 'lib/history';
import GuardedRoute from 'lib/route-guard';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CompletePage from 'pages/complete';

const pageConfig = [
  {
    pathKey: VPathKey.CONSENT,
    componentPath: 'pages/india/consent',
    component: createLazy(() => import('pages/india/consent')),
    agreeCheck: false,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.PAN_CARD,
    componentPath: 'pages/india/pan-card',
    component: createLazy(() => import('pages/india/pan-card')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.PAN_INFO,
    componentPath: 'pages/india/pan-info',
    component: createLazy(() => import('pages/india/pan-info')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.KTP_CARD,
    componentPath: 'pages/indo/ktp-card',
    component: createLazy(() => import('pages/indo/ktp-card')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.KTP_INFO,
    componentPath: 'pages/indo/ktp-info',
    component: createLazy(() => import('pages/indo/ktp-info')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.CARD_SELECT,
    componentPath: 'pages/global/card-select',
    component: createLazy(() => import('pages/global/card-select')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.CARD_UPLOAD,
    componentPath: 'pages/global/card-upload',
    component: createLazy(() => import('pages/global/card-upload')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.INFO_SUBMIT,
    componentPath: 'pages/global/info-submit',
    component: createLazy(() => import('pages/global/info-submit')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.XML_UPLOAD,
    componentPath: 'pages/india/xml-upload',
    component: createLazy(() => import('pages/india/xml-upload')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.CHECK,
    componentPath: 'pages/check',
    component: createLazy(() => import('pages/check')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.DEMO_WITH_ACCESS_KEY,
    componentPath: 'pages/demo',
    component: createLazy(() => import('pages/demo')),
    agreeCheck: false,
    sessionCheck: false,
  },
  {
    pathKey: VPathKey.DEMO,
    componentPath: 'pages/demo',
    component: createLazy(() => import('pages/demo')),
    agreeCheck: false,
    sessionCheck: false,
  },
  {
    pathKey: VPathKey.WAITING_ROOM,
    componentPath: 'pages/waiting-room',
    component: createLazy(() => import('pages/waiting-room')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.CHATTING_ROOM,
    componentPath: 'pages/chatting-room',
    component: createLazy(() => import('pages/chatting-room')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.PRECALL,
    componentPath: 'pages/precall',
    component: createLazy(() => import('pages/precall')),
    agreeCheck: true,
    sessionCheck: true,
  },
  {
    pathKey: VPathKey.COMPLETE,
    componentPath: 'pages/complete',
    component: createLazy(() => import('pages/complete')),
    agreeCheck: false,
    sessionCheck: false,
  },
  {
    pathKey: VPathKey.TEST_OUTBOUND,
    componentPath: 'pages/test/outbound',
    component: createLazy(() => import('pages/test/outbound')),
    agreeCheck: false,
    sessionCheck: false,
  },
  {
    pathKey: VPathKey.TEST_TRANSLATION,
    componentPath: 'pages/test/translation',
    component: createLazy(() => import('pages/test/translation')),
    agreeCheck: false,
    sessionCheck: false,
  },
  {
    pathKey: VPathKey.TEST_COMPONENTS,
    componentPath: 'pages/test/components',
    component: createLazy(() => import('pages/test/components')),
    agreeCheck: false,
    sessionCheck: false,
  },
];

const PageRoutes = () => (
  <Switch>
    {pageConfig.map((item) => {
      return (
        <GuardedRoute
          key={item.pathKey}
          sessionCheck={item.sessionCheck}
          agreeCheck={item.agreeCheck}
          pathKey={item.pathKey}
          path={vHistory.getPathnameByKey(item.pathKey)}
          component={item.component}
        />
      );
    })}
    <GuardedRoute
      pathKey={VPathKey.CLIENT_OUTBOUND_INIT}
      path={`${vHistory.getPathnameByKey(VPathKey.CLIENT_OUTBOUND_INIT)}/:transactionId`}
      component={createLazy(() => import('pages/outbound'))}
    />
    <GuardedRoute
      pathKey={VPathKey.CLIENT_INIT}
      path={`${PATH_PREFIX}/:transactionId`}
      component={createLazy(() => import('pages/client'))}
    />
    <Route render={() => <Redirect to={vHistory.getPathnameByKey(VPathKey.COMPLETE)} />} />
  </Switch>
);

export default PageRoutes;
